var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Effect } from '@ngrx/effects';
import { environment } from '../../environments/environment';
import { DummyAction, SetAppContextAction } from '../store';
import { toCategory } from '../store/categories/Category';
import { AuthHttpService } from '../services/auth-http.service';
import { Observable } from 'rxjs/internal/Observable';
import { defer } from 'rxjs/internal/observable/defer';
import { catchError, map } from 'rxjs/operators';
import { LOCALE_PREFIX } from '../configs';
import { of } from 'rxjs';
import * as Raven from 'raven-js';
var AppContextEffect = /** @class */ (function () {
    function AppContextEffect(http) {
        var _this = this;
        this.http = http;
        this.init$ = defer(function () {
            return _this.getAppContext();
        });
    }
    AppContextEffect.prototype.getAppContext = function () {
        return this.http.get("" + environment.urlPrefix + LOCALE_PREFIX + "/update_api/").pipe(map(function (res) {
            Raven.setUserContext({
                email: res.user.email,
                id: res.user.id,
            });
            return new SetAppContextAction({
                cities: res.cities,
                categories: res.categories.map(toCategory),
                user: res.user,
                service: res.service,
            });
        }), catchError(function () {
            return of(new DummyAction());
        }));
    };
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], AppContextEffect.prototype, "init$", void 0);
    return AppContextEffect;
}());
export { AppContextEffect };
